// src/components/ScrollToTop.jsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scrolls the window to the top whenever the pathname changes
    window.scrollTo(0, 0);
  }, [pathname]); // This effect re-runs when 'pathname' changes

  return null; // This component does not render any UI
}

export default ScrollToTop;